import React, { useCallback } from "react";
import { Input } from "../../style/Input";
import { LoginLabel } from "../../style/Label";
import { LoginHeading, } from "../../style/Login";
import { CustomDiv } from "../../style/shared";
import { Button } from "../../style/Button";
import { useHistory } from 'react-router-dom';
import { Logo1 } from "../logo/Logo";
import { isAdmin, verifyAuth } from "../../authverify";
import { serverUrl, EMAIL_IS_IN_USE, REGISTRATION_REQUEST_SUCCESS } from "../../appconst";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import "./signup.css";
import { TextField } from "@mui/material";
export class SignUp extends React.Component {

  constructor(props) {
    super(props);

    var data = JSON.parse(window.sessionStorage.getItem("usersession"))

    // if (data == null || !verifyAuth() || data.role !== "Admin") {
    //   this.props.history.push({
    //     pathname: '/',
    //   });
    // }

    this.state = {
      uname: "",
      password: "",
      designation: "",
      email: "",
      company: "",
      country: ""
    }

    // if (!verifyAuth() || !isAdmin) {
    //   this.props.history.push({
    //     pathname: '/',
    //   });
    // }

  }

  handleOnClick = () => {

    fetch(`${serverUrl}/api/auth/signup/request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "fullname": this.state.uname,
        "email": this.state.email,
        "password": this.state.password,
        "designation": this.state.designation,
        "country": this.state.country,
        "company": this.state.company,
        "role": "DemoUser"
      })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.message === EMAIL_IS_IN_USE) {
          alert(data.message)
        }
        else if (data.message === REGISTRATION_REQUEST_SUCCESS) {
          this.state.uname = "";
          this.state.password = "";
          this.state.designation = "";
          this.state.email = "";
          this.state.company = "";
          this.state.country = "";
          alert(data.message);
          this.forceUpdate();
          this.props.history.push({
            pathname: "/",
          });
        } else {
          alert("Error creating user");
        }
      })
      .catch(console.log);

  };
  render() {
    return (
      <>
        <Logo1 className="mob-visibility" />
        <Grid container className="min-h-100 main-box mobFlex-reverse" maxWidth="100%" alignContent="center">
          <Grid
            item xs={12}
            md={6}
            justifyContent="center"
            alignContent="center"
            className="min-h-100 info-wrap"
          >
            <Logo1 className="desk-visibility" />
            <Box className="content-wrap info">
              <div className="info-text">
                <p style={{ marginBottom: "6px", lineHeight: "28px" }}>
                  <b className="fs27">Doceree</b><br />
                  <b className="fs27">Partner Toolbox</b>
                </p>
                <p className="info-subtext">
                  A solution hub primarily for our agency partners
                </p>
                <br />
                <p className="info-link mt-0-xs">
                  <span style={{ fontWeight: 600 }}>Partner Toolbox is a mutual collaboration
                    between Doceree and agency partners</span> who are
                  looking to showcase the possibilities of reaching
                  out to HCPs to their life sciences clients. It
                  supports the partners to demonstrate new and
                  innovative ways of engaging with HCPs in an
                  convenient manner.
                </p>

              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} className="form-wrap">
            <Box className="content-wrap mt-0-xs">
              <Box className="sinUpForm">
                <LoginHeading>Sign Up</LoginHeading>
                <div className="inputBox">
                  <TextField
                    required
                    label="Name"
                    style={{
                      height: "45px",
                      width: "100%",
                    }}
                  />
                </div>
                <div className="inputBox">
                  <TextField
                    style={{
                      height: "45px",
                      width: "100%",
                    }}
                    required
                    label="Designation"
                    name="designation" onChange={(event) => this.setState({ designation: event.target.value })}
                  />
                </div>
                <div className="inputBox">
                  <TextField
                    style={{
                      height: "45px",
                      width: "100%",
                    }}
                    required
                    label="Email"
                    name="email" onChange={(event) => this.setState({ email: event.target.value })}
                  />
                </div>
                <div className="inputBox">
                  <TextField
                    style={{
                      height: "45px",
                      width: "100%",
                    }}
                    required
                    label="Company"
                    name="company" onChange={(event) => this.setState({ company: event.target.value })}
                  />
                </div>
                <div className="inputBox">
                  <TextField
                    style={{
                      height: "45px",
                      width: "100%",
                    }}
                    required
                    label="Country"
                    name="country" onChange={(event) => this.setState({ country: event.target.value })}
                  />
                </div>

                <Button
                  width="100%"
                  marginTop="10px"
                  height="45px"
                  backgroundImage="linear-gradient(to right,#A45BE4 0%, #6B42F6 70%)"
                  style={{ fontWeight: 600, fontSize: "18px" }}
                  onClick={this.handleOnClick}
                >
                  Submit
                </Button>
                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="20px 0px 10px 0"
                  className="text-center-xs text-center"
                  onClick={() => this.props.history.push({
                    pathname: "/",
                  })}
                >
                  Already have an account? <span style={{ color: "#B263DE", fontWeight: "600", cursor: 'pointer' }} >Sign in</span>
                </LoginLabel>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }
}
